import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";
import { Label } from "./label";

interface ReadOnlyFieldProps {
  label: string;
  children: React.ReactNode;
  /** Use input-like height (h-10) for single-line values */
  inline?: boolean;
  className?: string;
}

export const ReadOnlyField = ({ label, children, inline = false, className }: ReadOnlyFieldProps) => {
  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <div className={cn("rounded-md border border-input bg-muted px-3 text-sm", inline ? "flex h-10 items-center" : "py-2", className)}>
        {children}
      </div>
    </div>
  );
};
